import React from 'react';

const InactiveIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-inactive" />
    </div>
  );
};

export default InactiveIcon;
